// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ru: ChromeTranslations = {
  'nav.nextPage': 'следующая страница →',
  'nav.previousPage': '← предыдущая страница',
  'nav.continueToLevel': 'продолжить к уровню →',
  'nav.backToMenu': 'назад в меню →',
  'howto.page': 'страница {n} из {total}',
  'options.title': 'Настройки',
  'ui.language': 'Язык',
};
